import { CCol, CContainer, CFormCheck, CRow, CModal } from '@coreui/react-pro'
import { format } from 'date-fns'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import { postCollector } from 'src/apiHelper/collectorApi'
import Button from 'src/components/common/Button/Button'
import Loader from 'src/components/common/Loader/Loader'
import SelectTemplateCard from 'src/components/NewEncounter/ProgressNoteCard/SelectTemplateCard'
import {
  getProgressNoteConvertV2,
  getProgressNoteImage,
  getVisitCharts,
  getVisitHistory,
  saveChartProgressNote,
} from 'src/helper/backendHelper'
import { VISIT_STATUS } from '../../../../../utils/statusConstants'
import { COLLECTOR_URL } from '../../../../../apiHelper/apiRoute/collector'
import { toast } from 'react-toastify'
import {
  canProviderAccessNote,
  shouldHidePrivateNote,
} from '../../../../../utils/sharedChartFunctions'
import { noteAccessErrorMessage } from '../../../ProgressNote/progressNoteConstants'
import { SIDE_PANEL_TAB_COL_INDEXES, SYSTEM_ID } from '../../../sharedConstants'
import { setPanelDetails, setTabIndexes } from '../../../../../redux/sidePanel/sidePanelSlice'
import { getIsAi } from '../../../../../utils/sharedFeaturesFunctions'
import { refreshEncounter } from '../../../../../redux/sidePanel/sidePanelThunk'
import { selectStyleDark, selectStyleLight } from '../../../../../utils/sharedCareTeamLogic'
import { getTheme } from '../../../../../redux/user/userSlice'

const noteOption = [
  { label: 'All', value: 'All' },
  { label: 'Draft', value: 'Draft' },
  { label: 'Completed', value: 'Completed' },
  { label: 'Pending Review', value: 'Pending Review' },
]

const NewProgressNoteAction = ({ isOpen, onToggle, visit }) => {
  const [selectedTemplate, setSelectedTemplate] = useState()
  const [useDefaultNote, setUseDefaultNote] = useState(true)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const practice = useSelector((state) => state?.user?.practice)
  const provider = useSelector((state) => state?.user?.provider)
  const userId = useSelector((state) => state?.user?.user?._id)
  const theme = useSelector(getTheme)
  const practiceMedicalChartTemplates = useSelector(
    (state) => state?.user?.practiceMedicalChartTemplates,
  )

  const thisDate = useSelector((state) => state.census.activeDate) || new Date()

  const [filteredPreviousNote, setFilteredPreviousNote] = useState([])
  const [selectedFilter, setSelectedFilter] = useState('All')

  const [progressImg, setProgressImg] = useState()

  const [finalTemplate, setFinalTemplate] = useState()

  const [previousNotesSigned, setPreviousNotesSigned] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingNP, setIsLoadingNP] = useState(false)
  const [isLoading2, setIsLoading2] = useState(false)

  const [isInitialEncounter, setIsInitialEncounter] = useState(true)

  useEffect(() => {
    setIsLoading(true)

    if (visit?._id) {
      getVisitHistory(visit._id).then((res) => {
        if (res?.status === 'success') {
          let thisFacilityVisits = res?.resData?.filter(
            (item) => item?.facility_id === visit?.facility_id,
          )

          if (thisFacilityVisits?.length > 0) {
            setIsInitialEncounter(false)
          } else {
            setIsInitialEncounter(true)
          }

          let signedVisits = res?.resData?.filter((item) => item?.chart)
          setPreviousNotesSigned(signedVisits)
        } else {
          setIsInitialEncounter(true)
        }
      })
    }

    setIsLoading(false)
  }, [visit?._id])

  useEffect(() => {
    if (selectedFilter === 'Draft') {
      setFilteredPreviousNote(
        previousNotesSigned?.filter((item) => !Boolean(item?.chart?.signed_on)),
      )
    } else if (selectedFilter === 'Pending Review') {
      setFilteredPreviousNote(
        previousNotesSigned?.filter((item) => Boolean(item?.chart?.pending_review)),
      )
    } else if (selectedFilter === 'Completed') {
      setFilteredPreviousNote(
        previousNotesSigned?.filter((item) => Boolean(item?.chart?.signed_on)),
      )
    } else {
      setFilteredPreviousNote(previousNotesSigned)
    }
  }, [selectedFilter, previousNotesSigned, userId])

  const startNote = async () => {
    if (!canProviderAccessNote(visit, provider)) {
      toast.error(noteAccessErrorMessage)
      return
    }

    setIsLoading(true)

    if (finalTemplate) {
      let templatePayload = finalTemplate
      if (!finalTemplate?.from_v2 && finalTemplate?.charge_id) {
        let res = await getProgressNoteConvertV2(finalTemplate?.charge_id)

        if (res) {
          templatePayload = { ...res, from_v2: true }
        }
      }

      if (visit?.status === VISIT_STATUS.last) {
        const url = COLLECTOR_URL.CLONE.replace(
          '{visitId}',
          `${finalTemplate?.charge_id || visit?.visitId}`,
        )
        const req = {
          service_date: thisDate,
          status: VISIT_STATUS.checked_in,
          last_visit: null,
          encounterType: 'Subsequent',
        }

        const resClone = await postCollector(url, req)

        if (resClone?.status === 'success') {
          const clonedDetails = resClone.result
          let progressPayload = {
            ...templatePayload,
            patient_id: clonedDetails?.patient_id || visit?.patient?._id,
            initial_encounter: isInitialEncounter,
            encounterType: clonedDetails?.encounterType || 'Subsequent',
            diagnosisCodes: clonedDetails?.diagnosis_codes || visit?.diagnosis_codes,
            // TODO clonedDeets never has proc codes on it?...
            procedureCodes: clonedDetails?.procedure_codes || visit?.procedureCodes,
            from_v2: true,
          }

          saveChartProgressNote(resClone?.result?._id, progressPayload, 'newProgClone')
            .then((res) => {
              if (res?.status === 'success') {
                setIsLoading(false)

                // if ai flag is on, show the new ai encounter panel
                if (getIsAi()) {
                  dispatch(setTabIndexes({ side: SIDE_PANEL_TAB_COL_INDEXES.NOTE }))
                  dispatch(
                    setPanelDetails({
                      visitId: resClone?.result?._id,
                      isLastEncounter: false,
                    }),
                  )
                  dispatch(refreshEncounter({ encounterId: resClone?.result?._id }))
                  onToggle(false)
                  return
                }

                navigate(`/progressnote/${resClone?.result?._id}`)
                onToggle(false)
              }
            })
            .catch((e) => {
              console.error(e)
              toast.error('Unable to create note')
              setIsLoading(false)
            })
        } else {
          setIsLoading(false)
          toast.error(resClone?.message || 'Unable to create visit/note')
        }
      } else {
        let progressPayload = {
          ...templatePayload,
          patient_id: visit?.patient_id || visit?.patient?._id,
          initial_encounter: isInitialEncounter,
          encounterType: visit?.encounterType,
          diagnosisCodes: visit?.diagnosis_codes,
          procedureCodes: visit?.procedure_codes,
          from_v2: true,
        }

        saveChartProgressNote(visit?._id, progressPayload, 'newprog').then((res) => {
          if (res?.status === 'success') {
            setIsLoading(false)

            if (getIsAi()) {
              dispatch(setTabIndexes({ side: SIDE_PANEL_TAB_COL_INDEXES.NOTE }))
              dispatch(
                setPanelDetails({
                  visitId: visit?._id,
                  isLastEncounter: false,
                }),
              )
              dispatch(refreshEncounter({ encounterId: visit?._id }))
              onToggle(false)
              return
            }

            navigate(`/progressnote/${visit?.visitId}`)
            onToggle(false)
          }
        })
      }
    }
  }

  useEffect(() => {
    setFinalTemplate(selectedTemplate)
  }, [selectedTemplate])

  const onCheckRadio = (e) => {
    if (e.currentTarget?.value === 'new') {
      setFinalTemplate(selectedTemplate)
      setUseDefaultNote(true)
    } else {
      setIsLoadingNP(true)
      getVisitCharts(e.currentTarget?.value).then((res) => {
        if (res?.status) {
          if (!res?.data?.from_v2) {
            getProgressNoteConvertV2(res?.data?.charge_id).then((res) => {
              setFinalTemplate(res)
            })
          } else {
            if (practiceMedicalChartTemplates) {
              const temp = practiceMedicalChartTemplates?.find(
                (template) => template?.template === res?.data?.template,
              )
              res.data.title_print = temp?.title_print
            }
            setFinalTemplate(res.data)
          }
          setUseDefaultNote(false)
        }
      })

      getProgressNoteImage(e.currentTarget?.value, 'onCheckRadio').then((res) => {
        if (res?.status === 'success') {
          setProgressImg(res?.data)
        }
        setIsLoadingNP(false)
      })
    }
  }

  return (
    <div className="pn-selector">
      {isOpen && (
        <CModal
          className="model-progress-note"
          alignment="center"
          visible={isOpen}
          onClose={() => onToggle(false)}
          size="xl"
          fullscreen="lg"
        >
          <div className="model-main">
            {(isLoading || isLoading2) && <Loader color="primary" />}
            <div className="model-header">
              <div className="model-title">
                <h5>New Note</h5>
              </div>
              <div className="action">
                <i
                  className="far fa-xmark"
                  style={{ fontSize: '1.3em', cursor: 'pointer' }}
                  onClick={() => onToggle(false)}
                ></i>
              </div>
            </div>

            <div className="model-body">
              <CContainer>
                <CRow>
                  <CCol lg="7">
                    <div className="template-selection-holder">
                      <div className="template-inner">
                        <div className="select-template">
                          <SelectTemplateCard
                            setSelectedTemplate={setSelectedTemplate}
                            selectedTemplate={selectedTemplate}
                            setIsLoading={setIsLoading2}
                            onCheckRadio={onCheckRadio}
                            useDefaultNote={useDefaultNote}
                          />
                        </div>
                        {previousNotesSigned?.length > 0 && (
                          <div className="previous-template">
                            <div className="list-holder">
                              <div className="previous-note-header">
                                <p>Reuse a previous note:</p>
                                <div className="filter-holder">
                                  <Select
                                    menuShouldScrollIntoView={false}
                                    className="encounter-selectbox-input note-types"
                                    styles={theme === 'light' ? selectStyleLight : selectStyleDark}
                                    onChange={({ value }) => {
                                      setSelectedFilter(value)
                                    }}
                                    options={noteOption}
                                    value={noteOption?.find((opt) => opt.value === selectedFilter)}
                                  />
                                </div>
                              </div>

                              <div className="template-lists-holder">
                                {filteredPreviousNote?.map((item, index) => {
                                  const limitCopying = practice?.restrictVisitCloningToProvider
                                  const encounterMatchesCurrentProvider =
                                    provider?._id === item?.rendering_provider_id
                                  const showCopyButton =
                                    (!limitCopying || encounterMatchesCurrentProvider) &&
                                    !shouldHidePrivateNote(item?.chart, userId) &&
                                    item?.chart?.signed_user_id !== SYSTEM_ID

                                  const cosignerName = item?.cosign_provider
                                  const sspName = item?.incident_provider?.first_name
                                    ? item?.incident_provider?.first_name +
                                      ' ' +
                                      item?.incident_provider?.last_name
                                    : ''
                                  const name = sspName || cosignerName

                                  return (
                                    <div className="list-item" key={index}>
                                      <div className="radio-select">
                                        <CFormCheck
                                          type="radio"
                                          name="template-select"
                                          id="template-select"
                                          value={item?._id}
                                          aria-label="..."
                                          onChange={onCheckRadio}
                                          checked={item?._id === finalTemplate?.charge_id}
                                          disabled={!showCopyButton}
                                        />
                                        <div className="list-head">
                                          {item?.service_date_from && (
                                            <p className="name">
                                              {moment(item?.service_date_from).format('MM/DD/YYYY')}{' '}
                                              |{' '}
                                              {item?.rendering_provider_name
                                                ? item?.rendering_provider_name
                                                : ''}
                                              {name ? ` / ${name}` : ''}
                                            </p>
                                          )}

                                          <p className="txt">
                                            {item?.chart?.template} |{' '}
                                            {item?.chart?.initial_encounter
                                              ? 'Initial'
                                              : 'Subsequent'}
                                            {' | '}
                                            {Boolean(item?.chart?.signed_on) ? (
                                              <span className="text-white">Completed</span>
                                            ) : item?.chart?.pending_review ? (
                                              <span className="text-orange">Pending Review</span>
                                            ) : (
                                              <span className="text-gold">Draft</span>
                                            )}
                                          </p>
                                        </div>
                                        <div className="list-discription">
                                          <p
                                            dangerouslySetInnerHTML={{
                                              __html: item?.note_txt,
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )
                                })}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </CCol>
                  <CCol lg="5">
                    <div className="preview-note-template">
                      {isLoadingNP && <Loader />}
                      <div className="progress-note-wraper">
                        {finalTemplate?.signed_on ? (
                          <div className="progress-img-holder">
                            <picture>
                              <img src={progressImg} alt="note-img" />
                            </picture>
                          </div>
                        ) : (
                          <div className="progress-holder">
                            <div className="note-header">
                              <div className="header-row">
                                {visit?.patient_name && (
                                  <div className="head-col">
                                    <p>SERVICE DATE: {visit?.service_date_from}</p>
                                    <p>
                                      PATIENT: {visit?.patient_name} ({visit?.patient_dob})
                                    </p>
                                    <p>FACILITY: {visit?.facility_name}</p>
                                  </div>
                                )}

                                <div className="head-col">
                                  <p>{provider?.organization_name || ''}</p>
                                  <p>{provider?.phone || ''}</p>
                                </div>
                              </div>
                            </div>

                            <div className="note-body">
                              <div className="note-section-holder">
                                {finalTemplate?.title_print && (
                                  <center>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: finalTemplate?.title_print,
                                      }}
                                      className="note-title-txt"
                                    ></div>
                                  </center>
                                )}

                                <div className="note-section">
                                  {finalTemplate?.data?.map((section, index) => (
                                    <div className="section-holder" key={index}>
                                      {section?.title !== 'Diagnosis (ICD10)' &&
                                        section?.title !== 'E&M and procedure codes' && (
                                          <>
                                            <h6 className="title">{section?.title}</h6>

                                            {(section?.values || section?.instructions) && (
                                              <div className="section-item-holder">
                                                {section?.values ? (
                                                  <p
                                                    dangerouslySetInnerHTML={{
                                                      __html: Object.values(section?.values)?.join(
                                                        ',\n',
                                                      ),
                                                    }}
                                                  />
                                                ) : (
                                                  <p
                                                    dangerouslySetInnerHTML={{
                                                      __html: section?.instructions,
                                                    }}
                                                  />
                                                )}
                                              </div>
                                            )}
                                          </>
                                        )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                            {finalTemplate?.signed_on && (
                              <div className="p-note-footer">
                                <div className="date">
                                  ** Document e-signed by{' '}
                                  {provider?.organization_name
                                    ? provider?.organization_name
                                    : 'JULIA TEST, MD'}{' '}
                                  , on{' '}
                                  {format(
                                    new Date(finalTemplate?.signed_on),
                                    'MMM dd, yyyy hh:mm a',
                                  )}
                                  **
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CContainer>
            </div>
            <div className="model-footer">
              <Button color="primary" variant="full-width" onClick={startNote}>
                Start Note
              </Button>
            </div>
          </div>
        </CModal>
      )}
    </div>
  )
}

export default NewProgressNoteAction
